module.exports = {
  "title": "content hub",
  "sub_text": "discover, curate, distribute",
  "home": {
    "welcome": "Welcome",
    "notification": {
      "title": "notifications",
      "actions": {
        "delete_all": "Delete all"
      },
      "loading_message": "Loading Notifications",
      "empty_message": "There are no notifications for you yet.<br /> Stay tuned!"
    },
    "actions": {
      "create_asset": "Create Asset",
      "new_stream": "New Stream",
      "edit_hub": "Edit Hub",
      "clone_hub": "Clone Hub",
      "content_manager": "Content Map",
      "switch_hub": "Switch Hub",
      "explore": "Explore"
    },
    "filters": {
      "title": "Filters",
      "all_streams": "All Streams",
      "own_streams": "Own Streams",
      "shared_with_me": "Shared with me"
    },
    "edit": {
      "heading": "Manage Content",
      "sub_text": "Move this, remove that, or add more of something else.<br /> This section is yours to edit away!",
      "save_changes": "High-five! Your changes are saved!",
      "actions": {
        "create_section": "Create New Section"
      }
    }
  },
  "stream": {
    "followers": "Followers",
    "loading_message": "Fetching your content",
    "empty_message": {
      "title": "Knock, Knock,",
      "sub_text": "Ginger. Anybody in? <br/> There is no content in this stream yet."
    },
    "actions": {
      "edit_stream": "Edit stream",
      "delete_stream": "Delete stream",
      "manage_user": "Manage User <br /> Access",
      "add_section": {
        "title": "Add section",
        "placeholder": "Enter section name"
      },
      "add_group": {
        "title": "Add group",
        "placeholder": "Enter group name"
      },
      "add_asset": "Add asset",
      "rename": {
        "title": "Rename",
        "description": "Rename content below and click here to"
      },
      "delete": {
        "title": "Delete",
        "description": "Select content below and click here to",
        "error_message": "Select groups or assets to delete."
      },
      "copy": {
        "title": "Copy",
        "description": "Select content below and click here to",
        "map": "Map your files from to",
        "error_message": "Select groups or assets to copy."
      },
      "move": {
        "title": "Move",
        "description": "Select content below and click here to",
        "map": "Map your files from to",
        "error_message": "Select groups or assets to move."
      },
      "manage": "Manage Source"
    },
    "edit_stream": {
      "name": "Name",
      "placeholder": "Provide stream name",
      "description": "Description",
      "actions": {
        "change_background": "Change background"
      }
    },
    "empty_messages": {
      "no_stream": {
        "title": "Mmm... who moved my cheese?",
        "sub_text": "Sorry!  Some one passed you the wrong information. You were never supposed to see me :). The stream in me does not exist any longer.",
      },
    "not_authorised": {
      "title": "Who sets these rules, anyway?",
      "sub_text": "I’m sorry! It seems like I’m not authorised to show what you are looking for. I hate disappointing you :("
      }
    }

  },
  "group": {
    "actions": {
      "edit_group": "Edit group",
      "edit_group_thumbnail": "Edit group thumbnail",
      "add_section": {
        "title": "Add section",
        "placeholder": "Enter section name"
      },
      "add_group": {
        "title": "Add group",
        "placeholder": "Enter group name"
      },
      "add_asset": "Add asset",
      "rename": {
        "title": "Rename",
        "description": "Rename content below and click here to"
      },
      "delete": {
        "title": "Delete",
        "description": "Select content below and click here to",
        "error_message": "Select groups or assets to delete."
      },
      "copy": {
        "title": "Copy",
        "description": "Select content below and click here to",
        "map": "Map your files from to",
        "error_message": "Select groups or assets to copy."
      },
      "move": {
        "title": "Move",
        "description": "Select content below and click here to",
        "map": "Map your files from to",
        "error_message": "Select groups or assets to move."
      },
      "manage": "Manage Source"
    },
    "edit_group": {
      "name": "Name",
      "placeholder": "Provide group name",
      "description": "Description"
    },
    "errors": {
      "name": "Please provide a valid name",
      "delete": "Select groups or assets to delete.",
      "copy": "Select groups or assets to copy.",
      "move": "Select groups or assets to move."
    },
    "empty_messages": {
      "no_group":{
        "title": "Mmm... who moved my cheese?",
        "sub_text": "Sorry!  Some one passed you the wrong information. You were never supposed to see me :). The group in me does not exist any longer.",
    },
      "not_authorised": {
        "title": "Who sets these rules, anyway?",
        "sub_text": "I’m sorry! It seems like I’m not authorised to show what you are looking for. I hate disappointing you :("
      }
    }
  },
  "sliders": {
    "create_asset": {
      "title": "creating the asset as",
      "sub_text": "choose the type of asset you want to create",
      "create_pdf": "create documents",
      "create_pptx": "create presentations",
      "description": "merge, shuffle and save",
      "empty_message": {
        "asset_name": "You forgot to name your new asset",
        "create_pdf": {
          "title": "Craft Your Document Instantly",
          "sub_text": "Select the pages you want to bring onto your new document"
        },
        "create_pptx": {
          "title": "Curate your slideshow on the fly",
          "sub_text": "Add the slides you want to bring onto your new presentation"
        }
      },
      "confirmation": {
        "title": "A star is born - your new file! Where's its address?",
        "sub_text": "Choose where you want the asset to be saved",
        "save_file": "Save your file to"
      }
    },
    "create_stream": {
      "title": "create new stream",
      "cover_image": "cover image",
      "placeholder": "Add a stream name",
      "sub_text": "What's it all about",
      "where_to_add_it": "Where to add it?",
      "text_area": "Tell a story, only if you have one.",
      "errors": {
        "stream_name": "Please provide a valid Stream name.",
        "character_length": "Stream name cannot be greater than 200 characters"
      }
    },
    "clone_hub": {
      "title": "playing copycats, are we?",
      "sub_text": "clone this layout in a snap!"
    },
    "delete_section": {
      "title": "deleting",
      "sub_text": "Do you wish to delete this section?"
    },
    "manage_content_source": {
      "title": "manage content sources",
      "sub_text": "Organize imported assets from content sources",
      "map_folder": "Map a new folder",
      "in_progress": "In Progress",
      "headers": {
        "folder": "Folder",
        "last_sync": "Last Sync"
      },
      "sub_slider": {
        "connected_sources": {
          "title": "Connected Sources",
          "sub_text": "Map a new source to the stream",
          "confirm": "Map Files from {folderName} to {streamName}?",
          "actions": {
            "disconnect": "Disconnect"
          }
        },
        "toast": {
          "synchronised": "Synchronised",
          "synchronising": "Synchronising",
          "sync_process": "{state} folder {folderName} to {entityType} {entityName} {status}",
          "delete_process": "{state} mapping folder {folderName} from {entityType} {entityName} {status}",
          "new_assets": "New Assets",
          "existing_assets": "Existing Assets",
          "assets_deleted": "Assets Deleted",
          "groups_deleted": "Groups Deleted"
        }
      },
      "empty_message": {
        "rss_feed": "Map all files from your rss feed url?",
        "no_datasource": "You're not connected to any datasources yet.",
        "connect_now": "Connect Now",
      },
      "error_message": "Your authentication token to this content source has expired. Please re-authenticate to stay connected to your datasource."
    },
    "manage_user_access": {
      "sub_text": "Access to this stream can be configured at user level for additional security",
      "options": {
        "view_all": "View All",
        "edit_all": "Edit All",
        "read": "Read",
        "write": "Write"
      },
      "placeholder": "Type here to search",
      "owner": "Owner",
      "admin": "Admin",
      "empty_message": {
        "message": "The user(s) that you were looking for was not found.",
        "action": "Invite users"
      }
    },
    "delete_stream": {
      "sub_text": "Are you sure you would like to delete the selected stream?"
    },
    "delete_asset_group": {
      "title": "Deleting",
      "sub_text": "Are you sure you would like to delete the selected groups and assets?"
    },
    "copy": {
      "title": "Copying",
      "sub_text": "Select a Stream or a Group below to copy what you've selected"
    },
    "move": {
      "title": "Moving",
      "sub_text": "Select a Stream or a Group below to move what you've selected"
    },
    "switch_layout":{
      "title": "hub roulette, anyone?",
      "sub_text": "pick your preferred hub layout to match your styles." 
    }
  },
  "edit_hub": {
    "back": "Back to hub",
    "note": "Note",
    "detail": "Detail",
    "choose_layout": {
      "title": "Choose Layout",
      "streams": {
        "sub_text": "Choose a layout that can categorise your Streams and group them in the most relevant way.",
        "options": {
          "carousel_portrait": {
            "title": "Carousel - Potrait",
            "sub_text": "A carousel scroll of Streams with portrait thumbnails. Displays the most number of Streams per screen when compared to Carousel - Landscape.",
            "note": "You can add as many Streams as you'd like to in this layout."
          },
          "carousel_landscape": {
            "title": "Carousel - Landscape",
            "sub_text": "A carousel scroll of Streams with landscape thumbnails. Highlights the thumbnail designs for a visually rich experience.",
            "note": "You can add as many Streams as you'd like to in this layout."
          }
        }
      },
      "collections": {
        "sub_text": "Choose a layout that can showcase your pre-designed Collections in the best light.",
        "options": {
          "carousel": {
            "sub_text": "A carousel scroll of Collections with landscape thumbnails. Highlights the thumbnail designs for a visually rich experience.",
            "note": "You can add as many Collections as you'd like to in this layout."
          },
          "promoted_content": {
            "title": "Promoted Content",
            "sub_text": "Spotlight your prime-time content and ensure it stands tall and strong.",
            "note": "We recommend you to choose a Collection of your choice you'd like to promote."
          }
        }
      },
      "assets": {
        "sub_text": "Choose a layout that can enable easy discovery of Assets on your Hub.",
        "options": {
          "carousel": {
            "title": "Carousel",
            "sub_text": "A carousel scroll of Assets with portrait thumbnails.",
            "note": "You may add as many Assets as you'd like to in this layout."
          },
          "promoted_content": {
            "title": "Promoted Content",
            "sub_text": "Spotlight your prime-time content and ensure it stands tall and strong.",
            "note": "We recommend you to choose an Asset of your choice you'd like to promote."
          },
          "metro_combination": {
            "title": "Metro Combination",
            "sub_text": "One Asset is highlighted as an Info Card while the others are displayed as smaller thumbnails around it. Ideal for a group of Assets that are related.",
            "note": "Recommended number of Assets to display in this section is 4."
          },
          "info_cards": {
            "title": "Info Cards",
            "sub_text": "A descriptive snapshot of Assets with portrait thumbnails. Provides a helpful summary of the Assets and enables easy discovery.",
            "note": "Recommended number of Assets to display in each section is 3."
          }
        }
      },
      "layout_palette": {
        "title": "Layout Palette",
        "sub_text": "With a great range of layouts comes great responsibility! Don't forget to go through the description of each layout so you can choose the most suitable one."
      }
    },
    "select_content": {
      "title": "Selected Content",
      "sub_text": "Choose the selection method for Streams, Collections, and Assets that'll be displayed in the desired layouts.",
      "add_section_placeholder": "Enter section name",
      "alert": " Please select content for this layout to proceed.",
      "options": {
        "manual_selection": {
          "title": "Manual Selection",
          "sub_text": "Handpick the content you want to display on your Hub. Add the recommended number of Streams, Collections, and Assets for the chosen layouts for a superlative experience.",
          "slider_content": "If you enable Manual Selection, you will have to handpick each piece of content you want to display on your Content Hub, without any AI-generated recommendations. Sure you want to continue?",
          "empty_message": {
            "title": "Your Content Pail is Empty",
            "sub_text": "Layouts are no fun without the right content to be displayed in them. Go on and select the content you want to showcase on the Hub in the chosen layout!",
            "actions": {
              "select_content": "Select Content"
            }
          },
          "add_contents": {
            "title": "Add Contents",
            "sub_text": "Manually add contents that you want to display",
            "my_streams": "My Streams",
            "my_collection": "My Collection",
            "no_results": "No results found"
          }
        },
        "smart_filter": {
          "title": "Smart Filter",
          "sub_text": "Leave the content selection to our intelligent content recommendation filters! Based on the type of filter and layout you choose, content is dynamically selected and displayed.",
          "slider_content": "If you enable Smart Filters, the content to be displayed on your Content Hub will be determined by our intelligent content recommendation filters. Sure you want to continue?",
          "options": {
            "popular_with_your_teams": {
              "title": "Popular with your teams",
              "sub_text": "Assets with the most number of views to easily discover the ones that are a hit among your peers."
            },
            "continue_where_you_left": {
              "title": "Continue where you left",
              "sub_text": "Assets that were recently viewed by the user so they can pick up from exactly where they dropped off."
            },
            "recent_additions_to_hub": {
              "title": "Recent additions to Hub",
              "sub_text": "Assets that were recently added to the Content Hub so nobody has to doomscroll to find the latest additions."
            },
            "recently_updated_assets": {
              "title": "Recently updated Assets",
              "sub_text": "Assets that were recently updated / edited or changed by you and your team on the Content Hub."
            },
            "frequently_viewed_assets": {
              "title": "Frequently viewed Assets",
              "sub_text": "Assets that were most shared by your team. Your champion assets!"
            }
          }
        }
      }
    },
    "confirmation": "Ready to roll?",
    "placeholder": "Enter a section name",
    "actions": {
      "manage_content": "Manage Content"
    },
    "sliders": {
      "title": "Confirm Changes",
      "sub_text": "All changes made to this section will reflect for all users in the content hub. Are you sure you'd like to proceed?"
    }
  },
  "error_messages": {
    "data_source_action": "{entityType} cannot be {action} since it is synced with datasource",
    "no_layout_access": {
      "title": "Oops, looks like you don't have access to this layout!",
      "sub_text": "Please reach out to your Admin to get access to this Hub Layout.",
      "switch_layout": "Switch Layout",
    },
    "create_stream": {
      "title": "Let's create a new content stream for your teams?",
      "sub_text": "Approved content can now be streamed to your users. All you need to do is create new streams, add content and manage access levels for your teams.",
      "create_now": "Create Now"
    },
    "stream_access": {
      "title": "Uh oh! You need fuel to fly.",
      "message": "You don't have access to streams yet. Request your administrator for access now."
    }
  }
}